import { render, staticRenderFns } from "./placard_manuscript_premium_button.vue?vue&type=template&id=a1963518&scoped=true"
import script from "./placard_manuscript_premium_button.vue?vue&type=script&lang=js"
export * from "./placard_manuscript_premium_button.vue?vue&type=script&lang=js"
import style0 from "./placard_manuscript_premium_button.vue?vue&type=style&index=0&id=a1963518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1963518",
  null
  
)

export default component.exports